"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var subscription_manager_decorator_1 = require("../../shared/subscription-manager.decorator");
var services_1 = require("../../services");
var material_1 = require("@angular/material");
var ChangeHistoryDialogComponent = /** @class */ (function () {
    function ChangeHistoryDialogComponent(messageService, auditService, data, dialogRef, cdRef) {
        this.messageService = messageService;
        this.auditService = auditService;
        this.data = data;
        this.dialogRef = dialogRef;
        this.cdRef = cdRef;
        this.displayedColumns = ['userId', 'modifiedDate', 'note', 'version'];
        this.dataSource = [];
        this.itemsCount = 0;
        this.pageSizeOptions = [5, 10];
        this.currentPage = 0;
        this.itemsPerPage = 5;
        this.initialized = false;
        this.processId = data.processId;
    }
    ChangeHistoryDialogComponent.prototype.ngOnInit = function () {
        this.loadProcessHistory();
    };
    ChangeHistoryDialogComponent.prototype.ngAfterViewInit = function () {
        this.initialized = true;
        this.cdRef.detectChanges();
    };
    ChangeHistoryDialogComponent.prototype.loadProcessHistory = function () {
        var _this = this;
        var filter = new services_1.Filter(null, // this.processId,
        null, null, null, null, null, null, this.currentPage * this.itemsPerPage, this.itemsPerPage, services_1.Order.DESC, null, 'workflow-service');
        this.$sm.auditItems = this.auditService.getAuditItems(filter).subscribe(function (response) {
            _this.dataSource = response;
        });
        this.$sm.auditItemsCount = this.auditService.getAuditItemsCount(filter).subscribe(function (itemsCount) {
            _this.itemsCount = itemsCount;
        });
    };
    ChangeHistoryDialogComponent.prototype.paginatorUpdated = function (event) {
        this.currentPage = event.pageIndex;
        this.itemsPerPage = event.pageSize;
        this.loadProcessHistory();
    };
    ChangeHistoryDialogComponent.prototype.getMessage = function (key) {
        return this.messageService.getMessage(key);
    };
    ChangeHistoryDialogComponent.decorators = [
        { type: core_1.Component, args: [{
                    
                    selector: 'sis-change-history-dialog-component',
                    styles: [require('./change-history-dialog.component.css')],
                    template: require('./change-history-dialog.component.html')
                },] },
    ];
    /** @nocollapse */
    ChangeHistoryDialogComponent.ctorParameters = function () { return [
        { type: idm_message_language_service_client_js_1.MessageService, },
        { type: services_1.AuditService, },
        { type: undefined, decorators: [{ type: core_1.Inject, args: [material_1.MAT_DIALOG_DATA,] },] },
        { type: material_1.MatDialogRef, },
        { type: core_1.ChangeDetectorRef, },
    ]; };
    ChangeHistoryDialogComponent = __decorate([
        subscription_manager_decorator_1.SubscriptionManager(),
        __metadata("design:paramtypes", [idm_message_language_service_client_js_1.MessageService,
            services_1.AuditService, Object, material_1.MatDialogRef,
            core_1.ChangeDetectorRef])
    ], ChangeHistoryDialogComponent);
    return ChangeHistoryDialogComponent;
}());
exports.ChangeHistoryDialogComponent = ChangeHistoryDialogComponent;
//# sourceMappingURL=change-history-dialog.component.js.map